import {createContext} from 'react'
import {ModalPortalGuestHandler} from 'types'

export const ModalPortalGuestContext = createContext<
  ModalPortalGuestHandler | undefined
>(undefined)
